import { render, staticRenderFns } from "./refundWarning.vue?vue&type=template&id=098421a4&scoped=true"
import script from "./refundWarning.vue?vue&type=script&lang=js"
export * from "./refundWarning.vue?vue&type=script&lang=js"
import style0 from "./refundWarning.vue?vue&type=style&index=0&id=098421a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098421a4",
  null
  
)

export default component.exports